export const PERCENTAGE_TYPE = 'percentage';

type Metric = {
  displayType: string;
  enumName: string;
  name: string;
};

/**
 * **isMetricPercent**_(metric)_<br>
 * Determines if metric is a percentage type.
 * @param { Metric } metric: The metric to check if percent.
 * @returns { Boolean } If the metric is a percent.
 */
export const isMetricPercent = (metric: Metric) =>
  metric && metric.displayType && metric.displayType === PERCENTAGE_TYPE;

/**
 * **getMetricName**_(metric)_<br>
 * Get the name of a metric
 * @param { Metric } metric: The metric to get name from.
 * @returns { String } The metric name.
 */
export const getMetricName = (metric: Metric) => (metric ? metric.name : '');

/**
 * **getMetricName**_(metric)_<br>
 * Get the value of a metric (enumName)
 * @param { Metric } metric: The metric to get value from.
 * @returns { String } The metric value (enumName).
 */
export const getMetricValue = (metric: Metric) => (metric ? metric.enumName : '');
